import React from 'react';
import { Box, Button, Flex, Heading, Image } from '@chakra-ui/react';

const ProfileHeader = ({ name, logoSrc, onBack }) => (
  <Box bg="white" boxShadow="md" borderRadius="md" p={6} mb={4}>
    <Flex align="center" justify="space-between" mb={4}>
      <Flex align="center" position="relative" w="full" justify="center">
        <Button
          onClick={onBack}
          position="absolute"
          left={0}
          variant="ghost"
          aria-label="Go back"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" viewBox="0 0 16 16">
            <path
              fillRule="evenodd"
              d="M15 8a.75.75 0 0 1-.75.75H3.56l4.22 4.22a.75.75 0 1 1-1.06 1.06l-5.5-5.5a.75.75 0 0 1 0-1.06l5.5-5.5a.75.75 0 1 1 1.06 1.06L3.56 7.25H14.25A.75.75 0 0 1 15 8z"
            />
          </svg>
        </Button>
        <Heading as="h1" size="lg" textAlign="center">
          {name}
        </Heading>
      </Flex>
      <Image src={logoSrc} alt="Logo" h="58px" objectFit="contain" />
    </Flex>
  </Box>
);

export default ProfileHeader;
